// @flow weak

import React, {
  PureComponent
} from 'react';
import { button } from 'react-router-dom';
import Modal from 'react-modal';

const modalStyle = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    zIndex: 99
  },
  content: {
    top: "60px",
    maxWidth: "1140px",
    margin: "0 auto"
  }
};

class Item extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: (props.modalIsOpen) ? props.modalIsOpen : false,
      item: props.item,
      img: null,
      imgClass: 'blur',
      details: null,
      sizes: null,
      error: false,
      isClosing: false
    };

    this.closeModal = this.closeModal.bind(this);
    this.getSizes = this.getSizes.bind(this);
    this.handleChange = this.handleChange.bind(this);

    jQuery("#fbc-react").css("overflow-y", "hidden");
    jQuery("#fbc-react").css("height", "100vh");
  }

  closeModal() {
    if (this.state.isClosing) return;
    
    this.setState({ isClosing: true }, () => {
      jQuery('#loader').hide();
      this.setState({ modalIsOpen: false }, () => {
        // After our modal is closed, clean up parent modals
        jQuery('.canto-modal-overlay, #canto-elementor-modal, #canto-acf-modal').remove();
        this.props.handleModal(false);
        jQuery("#fbc-react").css("overflow-y", "scroll");
        jQuery("#fbc-react").css("height", "auto");
        jQuery('body').removeClass('modal-open ReactModal__Body--open');
        this.setState({ isClosing: false });
      });
    });
  }

  loadingHandler(event) {
    event.preventDefault();
  }
  uploadImage(event) {
    var self = this;
    var win = window || opener || parent || top;
    jQuery('#loader').show();
    event.preventDefault();
    var target = jQuery(event.target);
    var form = jQuery('#library-form');

    $.ajax({
      url: args.ajax_url,
      type: 'POST',
      dataType: 'json',
      data: form.serialize() + '&action=canto_copy_media&_wpnonce=' + encodeURIComponent(args.copy_media_nonce) + '&' + encodeURIComponent(target.attr('id')) + '=true&chromeless=1',
    })
      .done(function (response) {
        if (!response.success) {
          self.setState({ error: response.data && response.data.error ? response.data.error : 'Unknown error' });
          jQuery('#loader').hide();
        } else {
          var results = response.data;
          self.setState({ error: null });
          if (args.wp_editor === 'elementor') {
            win.parent.postMessage({
              type: 'canto_asset_selected',
              asset: {
                id: results.attachment_id,
                url: results.attachment_url,
                directUrl: results.attachment_url,
                alt: results.attachment_alt || results.attachment_title || '',
                name: results.attachment_title || results.attachment_filename || ''
              }
            }, '*');
          } else if (args.wp_editor === 'gutenberg') {
            let wp = win.top.wp;
            let blocks = wp.blocks;
            let dispatch = wp.data.dispatch('core/editor');
            dispatch.updateBlockAttributes(wpBlockClientId, {
              mediaID: results.attachment_id,
              mediaURL: results.attachment_url
            });
            switch (results.attachment_mime) {
              case 'image':
                var theBlock = blocks.createBlock('core/image', {
                  id: results.attachment_id,
                  url: results.attachment_url,
                });
                break;
              case 'video':
                var theBlock = blocks.createBlock('core/video', {
                  id: results.attachment_id,
                  src: results.attachment_url,
                });
                break;
              case 'audio':
                var theBlock = blocks.createBlock('core/audio', {
                  id: results.attachment_id,
                  src: results.attachment_url,
                });
                break;
              default:
                var theBlock = blocks.createBlock('core/file', {
                  id: results.attachment_id,
                  href: results.attachment_url,
                  fileName: results.attachment_filename || results.attachment_url,
                  textLinkHref: results.attachment_url
                });
                break;
            }
            dispatch.insertBlocks(theBlock, wpBlockIndex);
            dispatch.updateBlockAttributes(wpBlockClientId, { isOpen: false });
          } else if (args.wp_editor === 'acf') {
            win.parent.postMessage({
              type: 'CANTO_ACF_INSERT',
              assetData: results
            }, '*');
          } else {
            // For classic editor - use postMessage to communicate with parent window
            win.parent.postMessage({
              type: 'canto_media_insert',
              html: results.attachment,
              attachment_id: results.attachment_id,
              attachment_url: results.attachment_url
            }, '*');
          }
          self.closeModal();
        }
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
        self.setState({ error: errorThrown });
        jQuery('#loader').hide();
      });
  }

  readableFileSize(size) {
    var units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var i = 0;
    if (size >= 1024) {
      while (size >= 1024) {
        size /= 1024;
        ++i;
      }
      return size.toFixed(1) + ' ' + units[i];
    } else {
      return size + ' ' + units[0];
    }
  }

  componentDidMount() {
    this.setState({ imgClass: 'blur lazyloaded' });
    this.getDetails();
    this.getSizes();
  }

  componentWillUnmount() {
  }

  getDetails() {
    var self = this;
    $.ajax({
      url: args.ajax_url,
      type: "POST",
      dataType: 'json',
      data: {
        action: 'canto_detail',
        _wpnonce: args.detail_nonce,
        id: this.state.item.id,
        scheme: this.state.item.scheme,
      },
    })
      .done(function (response) {
        if (!response.success) { return; }
        var result = JSON.parse(response.data);
        var updateTime = result.default["Date modified"] ?
          result.default["Date modified"].substring(0, 4) + "-" + result.default["Date modified"].substring(4, 6) + "-" + result.default["Date modified"].substring(6, 8) : "-";
        var details = {
          "id": result.id,
          "scheme": result.scheme,
          "title": result.name,
          "alt": result.name,
          "name": result.name,
          "owner": result.owner,
          "ownerName": result.ownerName,
          "dimensions": result.default["Dimensions"],
          "size": self.readableFileSize(result.size),
          "time": result.time.substring(0, 4) + "-" + result.time.substring(4, 6) + "-" + result.time.substring(6, 8),
          "updated": updateTime,
          "description": result.description,
          "copyright": result.copyright,
          "terms": result.termsAndConditions,
          "termsAndConditions": result.termsAndConditions
        };
        self.setState({ details: details });
      });
  }

  getSizes() {
    var self = this;
    $.ajax({
      url: args.ajax_url,
      type: "POST",
      dataType: 'json',
      data: {
        action: 'canto_sizes',
        _wpnonce: args.sizes_nonce,
      },
    })
      .done(function (response) {
        if (response.success) {
          self.setState({ sizes: response.data });
        }
      });
  }

  handleChange(e) {
    var self = this;
    this.setState({
      details: {
        ...self.state.details,
        [e.target.name]: e.target.value
      }
    });
  }

  render() {
    var hideGutenberg = (args.wp_editor === 'gutenberg') ? 'none' : 'block';
    const content = (this.state.details) ?
      <div>
        <h5>Attachment Details</h5>
        <div className="attachment-info">
          <div className="details" style={{ lineHeight: "20px" }}>
            <div className="filename">{this.state.details.name}</div>
            <div className="uploaded">{this.state.details.updated}</div>
            <div className="filesize">{this.state.details.size}</div>
            <div className="dimensions">{(this.state.details.dimensions != null) ? this.state.details.dimensions.replace('*', ' x ') : ''}</div>
            <div className="owner">{this.state.details.owner}</div>
          </div>
        </div>
        <form encType="multipart/form-data" method="post" action={args.action} className="" id="library-form" style={{ display: "block", margin: "0 0 0 20px", position: "relative" }}>
          <input id="post_id" name="post_id" type="hidden" value={args.postID} />
          <input id="fbc_id" name="fbc_id" type="hidden" value={this.state.item.id} />
          <input id="fbc_scheme" name="fbc_scheme" type="hidden" value={this.state.item.scheme} />

          <div id="media-items" style={{ display: `${hideGutenberg}` }}>
            <div tabIndex="0" data-id="0" className="fbc attachment-details save-ready">

              <label data-setting="title" className="setting">
                <span className="name">Title</span>
                <input type="text" id="title" name="title" value={this.state.details.title.replace(/\.[^.$]+$/, '')} onChange={this.handleChange} />
              </label>

              <label data-setting="caption" className="setting">
                <span className="name">Caption</span>
                <textarea id="caption" name="caption"></textarea>
              </label>

              <label data-setting="alt" className="setting">
                <span className="name">Alt Text</span>
                <input type="text" id="alt-text" name="alt" value={this.state.details.alt.replace(/\.[^.$]+$/, '')} onChange={this.handleChange} />
              </label>

              <label data-setting="description" className="setting">
                <span className="name">Description</span>
                <textarea id="description" name="description" value={this.state.details.description} onChange={this.handleChange} />
              </label>

              <label data-setting="copyright" className="setting">
                <span className="name">Copyright</span>
                <input type="text" id="copyright" name="copyright" value={this.state.details.copyright} onChange={this.handleChange} />
              </label>

              <label data-setting="terms" className="setting">
                <span className="name">Terms Conditions</span>
                <textarea id="terms" name="terms" value={this.state.details.terms} onChange={this.handleChange} />
              </label>
            </div>
            <div className="attachment-display-settings" style={{ display: `${hideGutenberg}` }}>
              <h5>Attachment Display Settings</h5>

              <label className="setting">
                <span>Alignment</span>
                <select data-user-setting="align" name="align" data-setting="align" className="alignment">

                  <option value="left">Left</option>
                  <option value="center">Center</option>
                  <option value="right">Right</option>
                  <option value="none">None</option>
                </select>
              </label>

              <label className="setting">
                <span>Link To</span>
                <select name="link" className="link-to" data-setting="link" data-user-setting="urlbutton">
                  <option value="none">None</option>
                  <option value="file">Media File</option>
                  <option value="post">Attachment Page</option>
                </select>
                <input type="text" className="link-to-custom canto_hidden" data-setting="linkUrl" />
              </label>

              <label className="setting">
                <span>Size</span>
                <div dangerouslySetInnerHTML={{ __html: this.state.sizes }}></div>
              </label>

            </div>

          </div>
          <p className="ml-submit"></p>
          <br />
          {(this.state.error) &&
            <div className="alert alert-danger">
              <strong>Error</strong> {this.state.error}
            </div>
          }
          <div className="row">
            <div className="col-sm-3 text-left">
              <button className="button-secondary" onClick={this.closeModal.bind(this)}>Cancel</button>
            </div>
            <div className="col-sm-8 text-left">
              <button className="button-primary" id="insertAttachment" onClick={this.uploadImage.bind(this)}>Insert</button>
            </div>
          </div>

        </form></div> :
      <div>
        <form style={{ display: "block", margin: "0 0 0 20px", position: "relative" }}>
          <div id="media-items">
            <div tabIndex="0" data-id="0" className="fbc attachment-details save-ready">
              <h5>Attachment Details</h5>
              <div className="attachment-info">
                <div className="details">
                  <div className="filename"></div>
                  <div className="uploaded"></div>
                  <div className="filesize"></div>
                  <div className="dimensions"></div>
                  <div className="owner"></div>
                </div>
              </div>
            </div>
          </div>
          <p className="ml-submit"></p>
          <br />
          <div className="row">
            <div className="col-sm-3 text-left">
              <button onClick={this.closeModal.bind(this)}>Cancel</button>
            </div>
            <div className="col-sm-8 text-left">
              <button onClick={this.loadingHandler.bind(this)}>Loading ...</button>
            </div>
          </div>
        </form>
      </div>;



    return (
      <Modal
        isOpen={this.state.modalIsOpen}
        contentLabel="Attachment"
        style={modalStyle}>
        <div className="canto-class">
          <div className="col-sm-8">
            <img src={this.state.item.directUrlDetail} className={`img-responsive center-block ${this.state.imgClass}`} />
          </div>
          <div className="col-sm-4">
            {content}
          </div>
        </div>

      </Modal >
    );
  }
}

export default Item;



// WEBPACK FOOTER //
// ./src/app/views/item/Item.js